<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <v-card>
          <v-card-title>
            Registro de Asistencia Eventos | {{ session.convocatory }}
          </v-card-title>
          <v-card-text>
            <div>
              <div class="text-overline font-weight-light">Fecha de la sesión</div>
              <div>{{ filter.formatDate(session.date, 1) }}</div>
            </div>
            <div v-if="!notfound">
              <div class="text-overline font-weight-light">Registro</div>
              <div class="mb-3">Por favor ingresa tu número de documento:</div>
              <v-text-field v-model="participant.documento" variant="outlined" density="compact" 
                placeholder="Número de documento (Este campo solo acepta números)" 
                onkeypress="return event.charCode>=48 && event.charCode<=57"
                :error-messages="v$.documento.$errors.map(e => e.$message)"/>
                <div class="text-right">
                <v-btn color="primary" variant="flat" :loading="loading" text="Registrar mi asistencia" @click="register()"/>
              </div>
            </div>
            <div class="mt-3" v-if="notfound">
              <div class="text-center">
                <div class="text-h6">No registrado</div>
                <div>No te encuentras registrado en el sistema, por favor ingresa los siguientes datos para registrarte:</div>
              </div>
              <div class="data-input-content my-3">
                <v-text-field class="data-input" v-model="participant.nombres" variant="outlined" density="compact" label="Nombres"
                :error-messages="v2$.nombres.$errors.map(e => e.$message)"/>
                <v-text-field class="data-input" v-model="participant.apellidos" variant="outlined" density="compact" label="Apellidos" 
                :error-messages="v2$.apellidos.$errors.map(e => e.$message)"/>
                <v-text-field class="data-input" v-model="participant.correo_principal" variant="outlined" density="compact" label="Correo electrónico principal" 
                :error-messages="v2$.correo_principal.$errors.map(e => e.$message)"/>
                <v-text-field class="data-input" v-model="participant.contacto_principal" variant="outlined" density="compact" label="Número de contacto principal" 
                onkeypress="return event.charCode>=48 && event.charCode<=57"
                :error-messages="v2$.contacto_principal.$errors.map(e => e.$message)"/>
                
                <v-select class="data-input" v-model="participant.pais" variant="outlined" density="compact" label="País donde vives actualmente"
                :items="country" item-title="label" item-value="value" prepend-icon="mdi-help-circle-outline"
                :error-messages="v2$.pais.$errors.map(e => e.$message)"
                @update:modelValue="changeCountry()"
                @click:prepend="help.pais = !help.pais">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.pais" activator="parent" location="bottom">
                      País donde esta ubicado su lugar de trabajo o estudio
                    </v-tooltip>
                  </template>
                </v-select>
                
                <v-select class="data-input" v-model="participant.departamento" variant="outlined" density="compact" label="Departamento donde vives actualmente" 
                :items="department" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                :disabled="participant.pais !== 'Colombia'"
                :error-messages="v2$.departamento.$errors.map(e => e.$message)"
                @update:model-value="changeDepartment()">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.departamento" activator="parent" location="bottom">
                      Departamento donde esta ubicado su lugar de trabajo o estudio
                    </v-tooltip>
                  </template>
                </v-select>
                
                <v-select class="data-input" v-model="participant.ciudad" variant="outlined" density="compact" label="Ciudad donde vives actualmente" 
                :items="city" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                :disabled="participant.pais !== 'Colombia'" 
                :error-messages="v2$.ciudad.$errors.map(e => e.$message)">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.ciudad" activator="parent" location="bottom">
                      Ciudad donde esta ubicado su lugar de trabajo o estudio
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select class="data-input" v-model="participant.ubicacion_institucion" variant="outlined" density="compact" label="Zona de la entidad donde estás vinculado" 
                :items="location" item-value="value" item-title="label"
                :error-messages="v2$.ubicacion_institucion.$errors.map(e => e.$message)"/>

                <v-select class="data-input" v-model="participant.edad" variant="outlined" density="compact" label="Rango de edad" 
                :items="ages" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                @update:modelValue="changeRole()"
                :error-messages="v2$.edad.$errors.map(e => e.$message)">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.edad" activator="parent" location="bottom">
                      Rango de edad en el que te encuentras en la actualidad
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select class="data-input" v-model="participant.cargo" variant="outlined" density="compact" label="Rol o Eres" 
                :items="roles" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                :error-messages="v2$.cargo.$errors.map(e => e.$message)"
                @update:modelValue="changeTrayectory()">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.cargo" activator="parent" location="bottom">
                      Cargo o rol que desempeñas en tu lugar de trabajo o estudio
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select class="data-input" v-model="participant.trayectoria" variant="outlined" density="compact" label="Trayectoria en el cargo" 
                :items="trajectory" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                :error-messages="v2$.trayectoria.$errors.map(e => e.$message)">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.trayectoria" activator="parent" location="bottom">
                      Descripción de la trayectoria dentro del cargo o rol que desempeñas
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select class="data-input" v-model="participant.formacion" variant="outlined" density="compact" label="Último nivel de formación alcanzado" 
                :items="formation" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                :error-messages="v2$.formacion.$errors.map(e => e.$message)">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.formacion" activator="parent" location="bottom">
                      Nivel de formación más reciente alcanzado
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select class="data-input" v-model="participant.genero" variant="outlined" density="compact" label="Sexo de nacimiento" 
                :items="gender" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                :error-messages="v2$.genero.$errors.map(e => e.$message)">
                  <template v-slot:prepend>
                    <v-tooltip v-model="help.sexo" activator="parent" location="bottom">
                      Sexo biológico con el que naciste
                    </v-tooltip>
                  </template>
                </v-select>
              </div>
              <div>
                <div class="text-overline font-weight-medium">Política de tratamiento de datos</div>
                <div>
                  Al realizar esta inscripción Autorizo a <b>United Way Colombia</b> a realizar toma de fotografías, vídeos o entrevistas en las que aparezco y cedo el uso de mi imagen y registro de las actividades en las cuales participé, para los fines contemplas en la <a target="_blank" href="https://unitedwaycolombia.org/wp-content/uploads/2024/12/Politica_tratamientio_de_datos_2025.pdf">Política de Tratamiento de Datos</a> de dicha entidad, en la cual se incluyen, entre otras, la realización de piezas de comunicación interna y externa. Como titular de los datos, podré en cualquier momento, solicitar que la información sea modificada, actualizada o retirada de las bases de datos de <a target="_blank" href="https://unitedwaycolombia.org/">United Way Colombia</a>.
                </div>
              </div>
              <div>
                <div class="text-overline font-weight-medium">Política de comunicaciones</div>
                <div>
                  Autorizo el envío de correspondencia, correos electrónicos, comunicados, boletines virtuales, contacto telefónico o cualquier otro método con el fin de realizar actividades publicitarias, promocionales, de mercadeo, de divulgación de información educativa o misional de la Fundación, estudios de mercado o para la comunicación de las soluciones o campañas en pro de la educación. Podrás ajustar estos permisos desde tu perfil de beneficiario pasadas 24 horas de tu registro.
                </div>
              </div>
              <div>
                <v-checkbox v-model="accepted">
                  <template v-slot:label>
                    <div>Confirmo que he leído las políticas de privacidad y tratamiento de datos personales, así como mi deseo de inscribirme y participar de este evento.</div>
                  </template>
                </v-checkbox>
              </div>
              <div class="text-right">
                <v-btn variant="flat" color="primary" @click="confirm()" :loading="loading" :disabled="!accepted">Registrarme y marcar mi asistencia</v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>

    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">Resultado Asistencia</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="success.state = false"/>
        </div>        
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Registro de Asistencia Eventos</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
      </v-sheet>
    </v-dialog>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>
<script setup>
  import NavbarShowcase from '../components/navbar/NavbarShowcase';
  import axios from 'axios';
  import Params from '@/models/params';
  import Participant from '@/models/participant';
  import Session from '@/models/session';
  import Filters from '@/models/filters';
  import { ref, reactive, computed, onMounted } from "vue";
  import { useRoute } from 'vue-router';
  import { useVuelidate } from '@vuelidate/core';
  import { required, numeric, minLength, maxLength, minValue, maxValue, email, helpers } from '@vuelidate/validators';
  import moment from 'moment';

  const route = useRoute();

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const help = reactive({
    pais: false,
    departamento: false,
    ciudad: false,
    cargo: false,
    trayectoria: false,
    formacion: false,
    edad: false,
    sexo: false
  })
  

  const participant = reactive(new Participant);

  const params = ref(new Params);
  const session = ref(new Session);
  const filter = ref(new Filters);
  const accepted = ref(false)

  const process = ref(true);
  const loading = ref(false);
  const notfound = ref(false);

  const gender = ref(params.value.gender)
  const location = ref(params.value.location)
  const country = ref(params.value.country)
  const department = ref([])
  const city = ref([])
  const formation = ref([])
  const ages = ref([])
  const roles = ref([])
  const trajectory = ref([])

  session.value.code = route.params.session;

  const rules = computed(() => {
    return {
      documento: {
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Solo números.', numeric), 
        minLength: helpers.withMessage('Mínimo 6 números.', minLength(5)), 
        maxLength: helpers.withMessage('Máximo 15 números.', maxLength(15)), 
      }
    }
  });

  const rulesSteoTwo = computed(() => {
    return {
      nombres: { required: helpers.withMessage('Campo requerido.', required) },
      apellidos: { required: helpers.withMessage('Campo requerido.', required) },
      correo_principal: { 
        required: helpers.withMessage('Campo requerido.', required),
        email: helpers.withMessage('Formato inválido.', email)
      },
      contacto_principal: {
        required: helpers.withMessage('Campo requerido.', required),
        numeric: helpers.withMessage('Solo números.', numeric),
        minLength: helpers.withMessage('Mínimo 7 números.', minLength(7)), 
        maxLength: helpers.withMessage('Máximo 10 números.', maxLength(10)), 
      },
      pais: { required: helpers.withMessage('Campo requerido.', required) },
      departamento: { required: helpers.withMessage('Campo requerido.', required) },
      ciudad: { required: helpers.withMessage('Campo requerido.', required) },
      ubicacion_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      cargo: { required: helpers.withMessage('Campo requerido.', required) },
      trayectoria: { required: helpers.withMessage('Campo requerido.', required) },
      formacion: { required: helpers.withMessage('Campo requerido.', required) },
      edad: { required: helpers.withMessage('Campo requerido.', required) },
      genero: { required: helpers.withMessage('Campo requerido.', required) },
      migrantes: { 
        required: helpers.withMessage('Campo requerido.', required),
        numeric: helpers.withMessage('Solo números.', numeric),
        minValue: helpers.withMessage('Solo valores entre 0 y 100.', minValue(0)), 
        maxValue: helpers.withMessage('Solo valores entre 0 y 100.', maxValue(100)), 
      },
    }
  })

  const v$ = useVuelidate(rules, participant);
  const v2$ = useVuelidate(rulesSteoTwo, participant);

  async function load(){
    department.value = await params.value.department()
    formation.value = await params.value.formation()
    ages.value = await params.value.age()
    roles.value = await params.value.roles()
    const frm = new FormData;
    frm.append("action","sesion");
    frm.append("value",session.value.code);
    const result = await eject(frm);
    process.value = false;
    if(result.state){
      session.value.setDataAsisstance(result.data[0]);
      if(moment(session.value.date).diff(moment(),'days') < 0){
        error.text = "Registro de asistencia vencido, no se admiten más registros. Por favor comunícate con tu enlace UWC.";
        error.state = true;
      }
    }
  }

  async function register(){
    if(!await v$.value.$validate()){
      return
    }
    loading.value = true;
    const frm = new FormData;
    frm.append("action","asistenciadirecta");
    frm.append("value", session.value.code);
    frm.append("document", participant.documento);
    const result = await eject(frm);
    loading.value = false;
    if(result.state){
      switch (result.data[0].response) {
        case 0:
          notfound.value = true;
          break;
        case 1:
          success.text = "La asistencia ya se encuentra registrada, por favor no volver a registrar el mismo número de documento.";
          success.state = true;
          break;
        case 2:
          success.text = "Asistencia registrada exitosamente.";
          success.state = true;
          break;
      }
    }
  }

  async function confirm(){
    if(!await v2$.value.$validate()){
      return
    }
    loading.value = true;
    const frm = new FormData;
    frm.append("action", "asistenciaensitio");
    frm.append("session", session.value.code);
    frm.append("data", JSON.stringify(participant));
    const result = await eject(frm);
    loading.value = false;
    if(result.state){
      success.text = "Registro de usuario y asistencia han sido registrados exitosamente.";
      success.state = true;
      notfound.value = false;
      participant.reset();
    }else{
      error.text = "Hubo un error al intentar registrar el usuario, por favor comunícate tu enlace UWC.";
      error.state = true;
    }
  }

  //Auxiliar

  async function changeRole(){
    participant.trayectoria = null
    participant.formacion = null
    participant.cargo = null
    roles.value = await params.value.roles(participant.edad)
  }

  async function changeTrayectory() {
    trajectory.value = await params.value.trajectory(participant.cargo, participant.edad)
    formation.value = await params.value.formation(participant.edad)
  }

  async function changeCountry(){
    if(participant.pais !== 'Colombia'){
      participant.departamento = 100;
      participant.ciudad = 99998;
      participant.id_institucion = 1;
      city.value = await params.value.city(participant.departamento);
    }else{
      participant.departamento = null;
      participant.ciudad = null;
      participant.tipo_institucion = null;
      participant.id_institucion = null;
    }
  }

  async function changeDepartment(){
    participant.ciudad = null;
    city.value = await params.value.city(participant.departamento);
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'evento.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    load();
  });

</script>